const arts = [
    {
        alias: "exhibitionists",
        navigation: [
            {
                link: "/arts/exhibitionists",
                title: "Home",
                type: "internal",
            },
            {
                link: "/arts/exhibitionists/about-exhibitionists-1.3252400",
                title: "About",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/1.4380046",
                title: "Watch",
                type: "external",
            },
        ],
    },
    {
        alias: "thefilmmakers",
        description:
            "A fun, candid master class with some of the minds behind the greatest Canadian films.",
    },
    {
        alias: "inthemaking",
        navigation: [
            {
                link: "/arts/inthemaking",
                title: "Home",
                type: "internal",
            },
            {
                link: "https://cbc.ca/1.5230317",
                title: "Watch",
                type: "external",
            },
            {
                link: "https://cbc.ca/1.4796420",
                title: "About",
                type: "external",
            },
        ],
    },
    {
        alias: "interruptthisprogram",
        navigation: [
            {
                link: "/arts/interruptthisprogram",
                title: "Home",
                type: "internal",
            },
            {
                link: "/arts/interruptthisprogram/about-interrupt-this-program-1.3282382",
                title: "About",
                type: "internal",
            },
            {
                link: "https://www.cbc.ca/1.4380063",
                title: "Watch",
                type: "external",
            },
        ],
    },

    {
        alias: "crashgallery",
        navigation: [
            {
                link: "/arts/crashgallery",
                title: "Home",
                type: "internal",
            },
            {
                link: "/arts/crashgallery/about-crash-gallery-1.3227420",
                title: "About",
                type: "internal",
            },
            {
                link: "https://gem.cbc.ca/crash-gallery",
                title: "Watch",
                type: "external",
            },
        ],
    },
    {
        alias: "thecollective",
        navigation: [
            {
                link: "/arts/thecollective",
                title: "Home",
                type: "internal",
            },
            {
                link: "/arts/thecollective/about-the-collective-1.3246970?",
                title: "About",
                type: "internal",
            },
        ],
    },
    {
        alias: "eddyrogo",
        navigation: [
            {
                link: "/arts/eddyrogo",
                title: "Home",
                type: "internal",
            },
            {
                link: "/arts/eddyrogo/about-the-re-education-of-eddy-rogo-1.3242404",
                title: "About",
                type: "internal",
            },
        ],
    },
];

export default arts;
